/*
 * Copyright (c) 2018 Integral Agile, Inc. All rights reserved.
 *   Use of this file is subject to the terms and conditions defined in the file
 * 'LICENSE.txt'
 *   which is distributed in the root directory of this source code tree.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

const VrsDropdown = (props) => {
  const { type, defaultOptions, resultType, level, options, data } = props;

  const attributeValue = data[type];
  let vrsDropdownText = '-';

  if (attributeValue && options[attributeValue]) {
    const attributeValueText = options[attributeValue];

    if (attributeValueText === 'Extreme' && type !== 'rroe' && type !== 'tc')
      vrsDropdownText = 'X';
    else if (attributeValueText === 'XS') vrsDropdownText = 'XS';
    else if (attributeValueText === 'XL') vrsDropdownText = 'XL';
    else if (attributeValueText === 'XXL') vrsDropdownText = 'XX';
    else if (level > 1 && type === 'size') vrsDropdownText = attributeValueText;
    else if (
      level === 1 &&
      type === 'value' &&
      resultType &&
      resultType.kind === 'Defect'
    ) {
      const { values } = defaultOptions.severity_defaults;
      const selectedValue = values[attributeValue];
      if (selectedValue) {
        // check to see if the result has a severity value set
        vrsDropdownText = `S${selectedValue[selectedValue.length - 1]}`;
      }
    } else if (level === 1 && type !== 'size')
      vrsDropdownText = attributeValueText[0];
    else vrsDropdownText = attributeValue;
  }

  let newOptions = options;

  if (level > 1 && type !== 'size') {
    newOptions = defaultOptions.size_defaults?.values || [];
  }

  return (
    <div className="dropdown btn-component-div">
      <button
        type="button"
        id="vrs-dropdown"
        className={`icon ${type}`}
        data-toggle="dropdown"
        disabled={props.disabled}
        onClick={(e) =>
          props.toggleDropDownMenu(e, 'vrsMenu', {
            handleSelect: props.handleSelect,
            level,
            options: newOptions,
            attributes: data,
            field: type,
            index: props.rowIndex
          })
        }
      >
        {vrsDropdownText}
      </button>
    </div>
  );
};

VrsDropdown.propTypes = {
  handleSelect: PropTypes.func,
  type: PropTypes.string,
  data: PropTypes.object,
  options: PropTypes.object,
  disabled: PropTypes.bool
};

const mapStateToProps = (state) => ({
  defaultOptions: state.defaultOptionsReducer.defaultOptions
});

export default connect(mapStateToProps)(VrsDropdown);
